import { render, staticRenderFns } from "./Wizardot2data.vue?vue&type=template&id=75f22a6c&"
import script from "./Wizardot2data.vue?vue&type=script&lang=js&"
export * from "./Wizardot2data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports